import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';

const LanguageToggle = ({ className = '' }) => {
  const { isArabic, toggleLanguage, isTransitioning } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      disabled={isTransitioning}
      className={`language-toggle relative flex items-center h-9 w-[76px] rounded-full bg-[#F5F2EB] border border-[#E5E0D6] hover:border-[#8B6F47] transition-all duration-300 overflow-hidden ${className}`}
      aria-label={isArabic ? 'Switch to English' : 'التبديل إلى العربية'}
      data-testid="language-toggle"
    >
      {/* Sliding background */}
      <motion.div
        className="absolute top-1 bottom-1 left-1 w-[34px] bg-[#1C1C1C] rounded-full"
        initial={false}
        animate={{
          x: isArabic ? 34 : 0,
        }}
        transition={{
          type: 'spring',
          stiffness: 500,
          damping: 30,
        }}
      />
      
      {/* EN Label - FIXED SIZE via inline styles (bulletproof against RTL cascade) */}
      <span 
        className={`lang-label-en relative z-10 flex-1 text-center transition-colors duration-300 ${
          !isArabic ? 'text-white' : 'text-[#6B7280]'
        }`}
        style={{
          fontFamily: "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, monospace",
          fontSize: '13px',
          fontWeight: 500,
          letterSpacing: '0.03em',
          lineHeight: 1,
        }}
      >
        EN
      </span>
      
      {/* AR Label - FIXED SIZE via inline styles (bulletproof against RTL cascade) */}
      <span 
        className={`lang-label-ar relative z-10 flex-1 text-center transition-colors duration-300 ${
          isArabic ? 'text-white' : 'text-[#6B7280]'
        }`}
        style={{
          fontFamily: "'Harmattan', 'Traditional Arabic', sans-serif",
          fontSize: '18px',
          fontWeight: 500,
          lineHeight: 1,
        }}
      >
        ع
      </span>
    </button>
  );
};

export default LanguageToggle;
